import { render, staticRenderFns } from "./StatisticByCertificate.vue?vue&type=template&id=3ccfd70c&"
import script from "./StatisticByCertificate.vue?vue&type=script&lang=js&"
export * from "./StatisticByCertificate.vue?vue&type=script&lang=js&"
import style0 from "./StatisticByCertificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports